(function () {
  'use strict';

  var observer = null;
  var syncFrame = 0;

  function installStyles() {
    if (document.getElementById('tw-cart-legal-note-styles')) return;

    var style = document.createElement('style');
    style.id = 'tw-cart-legal-note-styles';
    style.textContent = [
      '.m-cart-drawer.tw-drawer .tw-drawer__foot > .tw-addon.tw-addon--above-summary{margin:0 0 12px!important;padding:0 0 10px!important;border-top:0!important;border-bottom:1px solid var(--tw-line)!important;}',
      '.m-cart-drawer.tw-drawer .tw-drawer__foot > .tw-cart-legal-note{display:block;width:100%;margin:14px 0 0;padding:0;color:#929292;font-size:9px;font-weight:400;line-height:1.35;letter-spacing:0;text-align:center;text-transform:none;}',
      '.m-cart-drawer.tw-drawer .tw-drawer__foot > .tw-cart-legal-note a{color:inherit;text-decoration:underline;text-underline-offset:2px;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function getDrawer() {
    return document.querySelector('.m-cart-drawer.tw-drawer');
  }

  function setDefaultOffFlag() {
    try {
      window.sessionStorage.setItem('tw_addon_declined', '1');
    } catch (error) {
      /* Storage can be unavailable in strict privacy mode. */
    }
  }

  function moveAddonAboveSummary(drawer, addon) {
    var summary = drawer.querySelector('.tw-drawer__foot > .tw-sum');
    if (!summary || !summary.parentNode) return;

    addon.setAttribute('data-tw-addon-auto', 'false');
    addon.classList.add('tw-addon--above-summary');

    if (addon.parentNode !== summary.parentNode || addon.nextElementSibling !== summary) {
      summary.parentNode.insertBefore(addon, summary);
    }
  }

  function ensureLegalNoteAtBottom(footer) {
    var note = footer.querySelector('.tw-cart-legal-note');

    if (!note) {
      note = document.createElement('p');
      note.className = 'tw-cart-legal-note';
      note.innerHTML = 'By placing your order, you agree to our <a href="/policies/terms-of-service">Terms &amp; Conditions</a> and <a href="/policies/privacy-policy">Privacy Policy</a>.';
    }

    if (note.parentNode !== footer || footer.lastElementChild !== note) {
      footer.appendChild(note);
    }
  }

  function ensureAddonLayout() {
    var drawer = getDrawer();
    if (!drawer) return;

    var footer = drawer.querySelector('.tw-drawer__foot');
    if (!footer) return;

    var addon = drawer.querySelector('[data-tw-addon]');
    if (addon) moveAddonAboveSummary(drawer, addon);

    ensureLegalNoteAtBottom(footer);
  }

  function scheduleSync() {
    if (syncFrame) return;

    syncFrame = window.requestAnimationFrame(function () {
      syncFrame = 0;
      ensureAddonLayout();
    });
  }

  function observeDrawer() {
    var drawer = getDrawer();
    if (!drawer || observer) return;

    observer = new MutationObserver(scheduleSync);
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function subscribeToCartEvents() {
    if (!window.MinimogEvents || !window.MinimogTheme) return;

    var events = window.MinimogTheme.pubSubEvents || {};
    if (events.cartUpdate) window.MinimogEvents.subscribe(events.cartUpdate, scheduleSync);
    if (events.openCartDrawer) window.MinimogEvents.subscribe(events.openCartDrawer, scheduleSync);
  }

  function init() {
    setDefaultOffFlag();
    installStyles();
    ensureAddonLayout();
    observeDrawer();
    subscribeToCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* TEENWEAR cart page add-on switch — isolated AJAX controller, no reload. */
(function () {
  'use strict';

  var busy = false;
  var pageObserver = null;

  function getPage() {
    return document.querySelector('[data-tw-cart-page]');
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addonId(root) {
    if (!root) return 0;

    var id = parseInt(root.getAttribute('data-addon-variant-id'), 10) || 0;
    if (id) return id;

    var box = root.querySelector('[data-tw-page-addon]');
    return box ? parseInt(box.getAttribute('data-variant-id'), 10) || 0 : 0;
  }

  function fetchCart() {
    return fetch(shopRoot() + 'cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function postJSON(path, body) {
    return fetch(shopRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response;
    });
  }

  function addonLines(cart, id) {
    return (cart && cart.items ? cart.items : []).filter(function (item) {
      return Number(item.variant_id) === Number(id);
    });
  }

  function formatMoney(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    var locale = (document.documentElement.lang || 'sk-SK').replace('_', '-');

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function updateSubtotal(root, cart) {
    if (!root || !cart) return;

    root.querySelectorAll('[data-cart-subtotal-price]').forEach(function (element) {
      element.textContent = formatMoney(cart.total_price, cart.currency);
    });
  }

  function applyState(root, cart) {
    if (!root || !cart) return;

    var id = addonId(root);
    var on = id > 0 && addonLines(cart, id).length > 0;

    root.querySelectorAll('[data-tw-page-addon-switch-v3]').forEach(function (input) {
      input.checked = on;
      input.setAttribute('aria-checked', on ? 'true' : 'false');

      var box = input.closest('[data-tw-page-addon]');
      if (box) box.classList.toggle('is-on', on);
    });

    updateSubtotal(root, cart);
    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function installSwitchStyles() {
    if (document.getElementById('tw-cart-page-addon-v3-styles')) return;

    var style = document.createElement('style');
    style.id = 'tw-cart-page-addon-v3-styles';
    style.textContent = [
      '[data-tw-cart-page] .tw-addon__toggle{position:relative;display:block;flex:0 0 auto;width:36px;height:21px;cursor:pointer;touch-action:manipulation;}',
      '[data-tw-cart-page] .tw-addon__toggle input{position:absolute;inset:0;width:100%;height:100%;opacity:0;margin:0;cursor:pointer;z-index:2;}',
      '[data-tw-cart-page] .tw-addon__toggle .tw-addon__track{pointer-events:none;}',
      '[data-tw-cart-page] .tw-addon__toggle input:checked~.tw-addon__track{background:var(--tw-ink);}',
      '[data-tw-cart-page] .tw-addon__toggle input:checked~.tw-addon__track::after{transform:translateX(15px);}',
      '[data-tw-cart-page] .tw-addon__toggle input:focus-visible~.tw-addon__track{outline:2px solid var(--tw-ink);outline-offset:2px;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function upgradeSwitches() {
    var root = getPage();
    if (!root) return false;

    var changed = false;

    root.querySelectorAll('.tw-addon__switch').forEach(function (label) {
      label.classList.remove('tw-addon__switch');
      label.classList.add('tw-addon__toggle');
      changed = true;
    });

    root.querySelectorAll('[data-tw-page-addon-switch],[data-tw-page-addon-switch-v2]').forEach(function (input) {
      input.removeAttribute('data-tw-page-addon-switch');
      input.removeAttribute('data-tw-page-addon-switch-v2');
      input.setAttribute('data-tw-page-addon-switch-v3', '');
      input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      changed = true;
    });

    return changed;
  }

  function removeAddonLines(cart, id) {
    var updates = {};

    addonLines(cart, id).forEach(function (item) {
      updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return Promise.resolve();
    return postJSON('cart/update.js', { updates: updates });
  }

  function saveState(root, desiredOn) {
    var id = addonId(root);
    if (!id) return Promise.reject(new Error('Missing add-on variant'));

    return fetchCart().then(function (cart) {
      var lines = addonLines(cart, id);

      if (desiredOn) {
        if (lines.length) return cart;

        return postJSON('cart/add.js', {
          items: [{ id: id, quantity: 1 }]
        }).then(fetchCart);
      }

      if (!lines.length) return cart;
      return removeAddonLines(cart, id).then(fetchCart);
    });
  }

  function handleChange(event) {
    var input = event.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-tw-page-addon-switch-v3')) return;

    var root = getPage();
    if (!root || !root.contains(input)) return;

    event.stopImmediatePropagation();

    var box = input.closest('[data-tw-page-addon]');
    var desiredOn = input.checked;

    input.setAttribute('aria-checked', desiredOn ? 'true' : 'false');
    if (box) box.classList.toggle('is-on', desiredOn);

    if (busy) return;

    busy = true;
    input.disabled = true;
    if (box) box.setAttribute('aria-busy', 'true');

    saveState(root, desiredOn)
      .then(function (cart) {
        applyState(root, cart);
      })
      .catch(function () {
        return fetchCart()
          .then(function (cart) {
            applyState(root, cart);
          })
          .catch(function () {
            input.checked = !desiredOn;
            input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
            if (box) box.classList.toggle('is-on', input.checked);
          });
      })
      .finally(function () {
        busy = false;
        input.disabled = false;
        if (box) box.removeAttribute('aria-busy');
      });
  }

  function syncFromCart() {
    var root = getPage();
    if (!root) return;

    fetchCart()
      .then(function (cart) {
        applyState(root, cart);
      })
      .catch(function () {});
  }

  function observePage() {
    var root = getPage();
    if (!root || pageObserver) return;

    pageObserver = new MutationObserver(function () {
      if (upgradeSwitches()) syncFromCart();
    });
    pageObserver.observe(root, { childList: true, subtree: true });
  }

  function initCartPageSwitch() {
    if (!getPage()) return;

    installSwitchStyles();
    upgradeSwitches();
    observePage();
    syncFromCart();
    document.addEventListener('change', handleChange, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageSwitch);
  } else {
    initCartPageSwitch();
  }

  window.addEventListener('pageshow', function () {
    upgradeSwitches();
    syncFromCart();
  });
})();
